import React from 'react';
import UnavailablePage from './UnavailablePage';
export default function Messages() {
  return <UnavailablePage title="Your Messages" description="Messaging is not connected yet. No messages can be sent or received here." />;
}
